jQuery('document').ready(() => {
    const form = document.getElementById('posts-filters');
    if (form) {
        const displayCount = (number) => {
            document.getElementById('total-posts').innerText = number;
        };

        const getCount = () => {
            const inputs = getInputs();
            const data = new FormData();

            data.append( 'action', 'get_count' );
            data.append( 'subject', inputs.subject );
            data.append( 'cities', inputs.cities );

            fetch(ajax.ajax_url, {
                method: "POST",
                credentials: 'same-origin',
                body: new URLSearchParams(data),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data) {
                        displayCount(data);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });

        };

        const getInputs = () => {
            const inputs = document.querySelectorAll('[data-js]');
            const final = {};
            final.subject = [];
            final.cities = [];
            inputs.forEach((element) => {
                if (element.dataset.js === 'subject-input' && element.checked) {
                    final.subject.push(element.value);
                }
                if (element.dataset.js === 'cities-input' && element.checked) {
                    final.cities.push(element.value);
                }
            });
            return final;
        };

        const stylistsInputs = document.querySelectorAll('[data-js="subject-input"]');
        stylistsInputs.forEach((input) => {
            input.addEventListener('change', () => {
                getCount();
            });
        });

        const citiesInputs = document.querySelectorAll('[data-js="cities-input"]');
        citiesInputs.forEach((input) => {
            input.addEventListener('change', () => {
                getCount();
            });
        });

        const getPosts = async (data) => {
            return await fetch(ajax.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
            },
                body: new URLSearchParams(data),
            });
        };

        const updateSeeMoreButton = (status) => {
            const button = document.querySelector('.see-more a');
            if (button !== null) {
                switch (status) {
                    case 'loading' :
                        button.classList.add('loading');
                        button.style.pointerEvents = "none";
                        break;
                    case 'loaded' :
                        button.classList.remove('loading');
                        button.style.pointerEvents = "auto";
                        break;
                    case 'hide' :
                        button.parentElement.style.display = 'none';
                        button.style.pointerEvents = "none";
                        break;
                    case 'show' :
                        button.parentElement.style.display = 'block';
                        button.style.pointerEvents = "auto";
                        break;
                }
            }
        };

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const inputs = getInputs();

            const data = new FormData();
            let orderBy = document.querySelector('input[name="orderby"]:checked');
            if (!orderBy) {
                orderBy = 'DESC';
            }
            data.append( 'action', 'get_selected_posts' );
            data.append( 'subjects', inputs.subject );
            data.append( 'cities', inputs.cities );
            data.append( 'orderby', orderBy );
            data.append( 'page', 1 );

            document.getElementById('open-filters-btn').innerText = document.getElementById('total-posts').innerText;
            const hiddenInput = document.getElementById('data-more');

            if (hiddenInput !== null) {
                hiddenInput.dataset.subject = inputs.subject;
                hiddenInput.dataset.cities = inputs.cities;
                hiddenInput.dataset.orderby = orderBy;
                hiddenInput.dataset.page = 1;
            }

            const request = getPosts(data);

            request.then((resp) => resp.json())
                .then((response) => {
                    if (response.status === 200) {
                        const articlesContainer = document.querySelector('#articles-container');
                        if (articlesContainer) {
                            articlesContainer.innerHTML = '';
                            for (let i =0; i < response.articles.length; i++) {
                                articlesContainer.insertAdjacentHTML( 'beforeend', response.articles[i]);
                            }
                            if (response.hideButton) {
                                updateSeeMoreButton('hide');
                                updateSeeMoreButton('loaded');
                            } else {
                                updateSeeMoreButton('show');
                                updateSeeMoreButton('loaded');
                            }
                        }
                    }
                    form.reset();
                });
        });

        const seeMoreButton = document.querySelector('.see-more a');
        if (seeMoreButton) {
            seeMoreButton.addEventListener('click', (e) => {
                e.preventDefault();

                updateSeeMoreButton('loading');
                const moreInput = document.getElementById('data-more');
                const data = new FormData();
                const pageInput = parseInt(moreInput.dataset.page);

                data.append('action', 'get_more_posts_ajax');
                data.append('page', (pageInput + 1));
                data.append('subjects', moreInput.dataset.subject);
                data.append('cities', moreInput.dataset.cities);
                data.append('orderby', moreInput.dataset.orderby);

                moreInput.dataset.page = pageInput + 1;

                const request = getPosts(data);

                request.then((resp) => resp.json())
                    .then((response) => {
                        if (response.status === 200) {
                            const articlesContainer = document.querySelector('#articles-container');
                            if (articlesContainer) {
                                for (let i =0; i < response.articles.length; i++) {
                                    articlesContainer.insertAdjacentHTML( 'beforeend', response.articles[i]);
                                }
                                if (response.hideButton) {
                                    updateSeeMoreButton('hide');
                                    updateSeeMoreButton('loaded');
                                } else {
                                    updateSeeMoreButton('show');
                                    updateSeeMoreButton('loaded');
                                }
                            }
                        }
                    });
            })
        }

        const openFilters = document.querySelector('.open-filters');
        if (openFilters) {
            openFilters.addEventListener('click', () => {
                getCount();
            })
        }
    }
});
